export enum SkinTone {
  Default = 0,
  Light,
  MediumLight,
  Medium,
  MediumDark,
  Dark,
}
